export const REQUESTOR = 'category-page'
